export enum ValueChainServiceProps {
  TOTAL_PAGES = 'totalPages',
  TOTAL_ITEMS = 'totalItems',
  CURRENT_PAGE = 'currentPage',
  DATA = 'data',
  
}